import React from "react";
import Shifts from "screens/Shifts/index";
const AssignedShift = () => {
  return <Shifts status="assigned" />;
};

export default AssignedShift;
